import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { BtwLink } from '../BtwLink';
import { BaseError } from './BaseError';
export function UnhandledError() {
    const subheading = (_jsxs(_Fragment, { children: ["It looks like there was an unexpected error. It pains us to ask, but please can you try refreshing the page? If the problem persists,", ' ', _jsx(BtwLink, { href: "mailto:help@ballparkhq.com", target: "_blank", variant: "current", children: "get in touch" }), "."] }));
    return _jsx(BaseError, { heading: "Something went wrong", subheading: subheading });
}
